<template>
  <input-select
    :id="id"
    :name="name"
    placeholder="Please Select..."
    type="select"
    :value="value"
    :options="genderOptions"
    :error="error"
    :label="label"
    @input="emitChange"
  />
</template>

<script>
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  name: 'GenderSelect',
  components: {
    InputSelect
  },
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    empty_label: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: null
    },
    selectOptions: {
      type: Array,
      required: true
    }
  },
  computed: {
    genderOptions() {
      const options = this.selectOptions;

      if (this.empty_label) options.splice(0, 0, { id: '', display_label: this.empty_label });

      return options;
    }
  },
  methods: {
    emitChange(val) {
      this.$emit('input', val);
    }
  }
};
</script>

<style></style>
